// extracted by mini-css-extract-plugin
export default {"amenities_container":"Amenities_amenities_container__4b0Yx","amenity":"Amenities_amenity__IM+R3","no_amenities":"Amenities_no_amenities__3n72t"};